<template>
  <div class="passport_div">
    <div class="passport_header">
        <div class="passport_header_01">
            <div class="passport_01">
                <div class="header_logo" @click="toIndex"></div>
            </div>
        </div>
    </div>
    <div class="login_context">
        <router-view/>
    </div>
    <div class="passport_footer">
        <div class="login_buttn">
            <ul>
                <li @click="toArticleDetail(1)"><span>购物流程</span>&emsp;|&emsp;</li>
                <li @click="toArticleDetail(4)"><span>支付方式</span>&emsp;|&emsp;</li>
                <li @click="toArticleDetail(31)"><span>配送方式</span>&emsp;|&emsp;</li>
                <li @click="toArticleDetail(2)"><span>开票流程</span>&emsp;|&emsp;</li>
                <li @click="toArticleDetail(28)"><span>公司介绍</span>&emsp;|&emsp;</li>
                <li @click="toIndex"><span>科研用品数字化服务平台</span></li>
            </ul>
            <div>版权所有 &copy; 苏州生科云选生物科技有限公司 苏ICP备2022004222号</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {};
  },
  methods: {
    toIndex(){
        this.$router.push({path: "/"});
    },
    toArticleDetail(articleId){
      this.$router.push({ path: "/article/articleDetail",
                          query: {
                            id:articleId
                        }});
      this.reload()
    }
  }
};
</script>
<style scoped>
.passport_div{
    width: 100%;
    height: calc(100vh);
    /* text-align:center; */
}
.passport_header{
    width: 100%;
    box-shadow: 0px 7px 7px -7px #eee;
}
.passport_header_01{
    width: 62.5vw;
    height:9vh;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.passport_01{
    display: flex;
    justify-content: center;
    align-items: center;
}
.header_logo{
    width: 173px;
    height: 41px;
    float: left;
    background-image: url('https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/login/pcmallTop.png');
    background-repeat: no-repeat;
    background-size: 9vw 4.49vh;
}
/* 中间 */
.login_context{
    width: 100%;
    height:80vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
/* 底部 */
.passport_footer{
    width: 100%;
    height: 11vh;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px -7px 7px -7px #eeeeee;
}
.login_buttn{
    width: 62.5vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #999999;
}
.login_buttn ul{
    width: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.login_buttn ul li{
    list-style: none;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/passportMain.vue